import { Job } from "../../../../../models/job";
var AddCandidatesFromJobBoardsController = /** @class */ (function () {
    /*@ngInject*/
    function AddCandidatesFromJobBoardsController($rootScope, $sce, resumeService, jobService, planService, companyService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$sce = $sce;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.planService = planService;
        this.companyService = companyService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    AddCandidatesFromJobBoardsController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.job = {};
        this.jobBoardDetails = [];
        this.requisitionDetails = {};
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.jobBoardsResumePullLeft = 0;
        this.jobBoardsPullResumePulled = 0;
        this.activeJobBoardsFilterTabNumber = 0;
        // flags
        this.isJobBoardSelected = false;
        this.isGetCandidateFetchCalled = false;
        this.isParametersEditable = true;
        this.isLoading = true;
        this.isTrialPlanActive = false;
        this.isCorporate = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.savingFlag = false;
        this.getPlanDetails(function () {
            if (_this.isTrialPlanActive) {
                _this.getJobBoardsResumePullLimits();
            }
        });
        this.getJob(function () {
            _this.getAllJobBoards(function () {
                _this._setJobBoardDetails();
                _this.getJobBoardParameters();
            });
            _this.getRequisitionDetails();
            _this.getRadiusAndRecencyOptions();
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getPlanDetails = function (successCallback) {
        var _this = this;
        this.planService.getCompanyPlanDetails(this.companyId, function (data) {
            if (!_.isNull(data.features) && data.features.length) {
                _this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getJobBoardsResumePullLimits = function () {
        var _this = this;
        this.planService.getAvailableJobBoardsPullCount(this.companyId, function (data) {
            _this.jobBoardsResumePullLeft = data["jobBoardResumesLeftCount"];
            _this.jobBoardsPullResumePulled = data["jobBoardResumesPulledCount"];
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getJobBoardParameters = function () {
        var _this = this;
        this.jobService.getJobBoardParameters(function (data) {
            _this.jobBoardParameters = data;
            _this.parseJobBoardParameters();
            _this.isLoading = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype.parseJobBoardParameters = function () {
        var _this = this;
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (!_.isNull(val.daxtraCode)) {
                var flags = [];
                var jobBoardsParams = _this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode];
                flags.push(true); // location supported by all job boards
                flags.push(_this._isParameterSupported(jobBoardsParams, "postcode"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "radius"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "jobType"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "recency"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "education"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "industry"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "salary"));
                val.flags = flags;
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
    };
    AddCandidatesFromJobBoardsController.prototype._isParameterSupported = function (jobBoardParameters, parameter) {
        return (jobBoardParameters.indexOf(parameter) == -1) ? false : true;
    };
    AddCandidatesFromJobBoardsController.prototype.getJob = function (successCallback) {
        var _this = this;
        this.jobService.getJob(this.jobId, function (data) {
            _this.job = _this._parseJobResponse(data);
            successCallback(data);
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype._parseJobResponse = function (data) {
        var tempJob = new Job();
        tempJob.id = data.id;
        tempJob.title = data.title;
        if (_.isNull(data.clientorbu)) {
            tempJob.clientorbu = null;
        }
        else {
            tempJob.clientorbu = {
                name: data.clientorbu.name,
                id: data.clientorbu.id,
                shortName: data.clientorbu.shortName
            };
        }
        tempJob.jobType = data.jobType;
        tempJob.location = data.location;
        tempJob.locationLabel = '-';
        if (!_.isNull(tempJob.location)) {
            if (!_.isNull(data.location.city)) {
                tempJob.locationLabel = data.location.city;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.state;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.locationLabel = '-';
                }
            }
            else {
                if (!_.isNull(data.location.state)) {
                    tempJob.locationLabel += ', ' + data.location.state;
                }
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.zipcode;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.zipcode = '-';
                }
            }
            else {
                if (!_.isNull(data.location.zipcode)) {
                    tempJob.locationLabel += ', ' + data.location.zipcode;
                }
            }
        }
        tempJob.educationList = data.educationList;
        tempJob.licensePreferences = data.licensePreferences;
        tempJob.radius = data.radius;
        tempJob.recency = data.recency;
        tempJob.salary = data.salary;
        tempJob.industry = data.industry;
        tempJob.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
            angular.forEach(tempJob.jobBoardDetails, function (val, key) {
                if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
            tempJob.resumesToPullPerJobBoardCount = tempJob.licensePreferences.resumesToPullPerJobBoardCount;
        }
        tempJob.daxtraParameters = data.daxtraParameters;
        //advanced params exist set Advanced filters tab as active
        if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
            this.activeJobBoardsFilterTabNumber = 1;
        }
        tempJob.advancedParametersImage = this.$sce.trustAsResourceUrl(data.advancedParametersImage);
        return tempJob;
    };
    AddCandidatesFromJobBoardsController.prototype.getAllJobBoards = function (successCallback) {
        var _this = this;
        var buId = null;
        if (!_.isNull(this.job.clientorbu) && this.isCorporate) {
            buId = this.job.clientorbu.id;
        }
        this.resumeService.getResumeSourceTypes(this.companyId, buId, function (data) {
            if (data.length > 0) {
                angular.forEach(data, function (val, key) {
                    val.boardId = val.id;
                    val.enabled = true;
                    delete val.id;
                });
                _this.jobBoardDetails = data;
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype._setJobBoardDetails = function () {
        var _this = this;
        this.job.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
            angular.forEach(this.job.jobBoardDetails, function (val, key) {
                if (_.findIndex(_this.job.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (val.enabled == true) {
                _this.isJobBoardSelected = true;
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getRadiusAndRecencyOptions = function () {
        var _this = this;
        this.jobService.getRadiusAndRecencyOptions(function (data) {
            console.log('options');
            console.log(data);
            _this.radiusOptions = data.radius;
            _this.recencyOptions = data.recency;
            if (_.isNull(_this.job.radius)) {
                _this.job.radius = data.defaultRadius[0];
            }
            if (_.isNull(_this.job.recency)) {
                _this.job.recency = data.defaultRecency[0];
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype.checkStatusAndGetResumesFromJobBoards = function () {
        var _this = this;
        this.isGetCandidateFetchCalled = true;
        this.jobService.getGetMoreResumesJobStatus(this.job.id, function (jobInProgress) {
            if (jobInProgress == true) {
                _this.isGetCandidateFetchCalled = false;
                _this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
            }
            else {
                _this.getResumesFromJobBoards();
            }
        }, function (error) {
            _this.isGetCandidateFetchCalled = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getResumesFromJobBoards = function () {
        var _this = this;
        this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, function (data) {
            _this.isGetCandidateFetchCalled = false;
            if (_this.saveCallback) {
                _this.saveCallback();
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                message: "Candidates are being fetched from Job Boards. You will be notified once the candidates are fetched",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }, function (error) {
            _this.isGetCandidateFetchCalled = false;
            //Resume pull failed
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-times fa-fw fa-lg'></i><strong>Fail!</strong></div>",
                message: error.message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    };
    AddCandidatesFromJobBoardsController.prototype.getRequisitionDetails = function () {
        var _this = this;
        this.jobService.getRequisitionDetails(this.job.id, this.companyId, function (data) {
            _this.requisitionDetails = data;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    AddCandidatesFromJobBoardsController.prototype.onJobBoardSelectionChange = function () {
        var _this = this;
        this.isJobBoardSelected = false;
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (val.enabled == true) {
                _this.isJobBoardSelected = true;
            }
        });
    };
    return AddCandidatesFromJobBoardsController;
}());
AddCandidatesFromJobBoardsController.$inject = ['$rootScope', '$sce', 'resumeService', 'jobService', 'planService', 'companyService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-candidates-from-job-boards.html';
import * as TEMPLATE from 'raw-loader!./add-candidates-from-job-boards.html';
export var AddCandidatesFromJobBoardsComponent = {
    selector: 'addCandidatesFromJobBoards',
    component: {
        bindings: {
            jobId: '@',
            saveCallback: '&'
        },
        controller: AddCandidatesFromJobBoardsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/add-candidates-from-job-boards.html'
    }
};
//# sourceMappingURL=add-candidates-from-job-boards.component.js.map